<div class="p-6 tag-management-container flex-table-page">
  <!-- Header -->
  <div class="mb-6 flex-table-header">
    <h2 class="text-2xl font-semibold text-gray-800 mb-4">Tag Management</h2>
  </div>

  <!-- Search Form -->
  <app-search-form
    [searchFormat]="searchFields"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  ></app-search-form>

  <!-- Action Button -->
  <div class="mb-4 flex justify-end flex-table-header">
    <p-button
      label="New Tag"
      severity="info"
      size="small"
      (onClick)="onNew()"
      class="action-btn"
    />
  </div>

  <!-- Data Table -->
  <div class="flex-table-section">
    <app-data-table
      [dataSource]="filteredTags()"
      [columns]="tableColumns"
      [loading]="loading()"
      [totalRecords]="totalItems()"
      [rows]="itemsPerPage()"
      [first]="currentPage() * itemsPerPage()"
      [hasCheckColumn]="false"
      scrollHeight="flex"
      (pageChange)="onPageChange($event)"
    >
    <!-- Custom Status Template -->
    <ng-template #statusTemplate let-status>
      <p-tag
        [value]="getTagValue(status)"
        [severity]="getTagSeverity(status)"
        styleClass="status-tag"
      />
    </ng-template>

    <!-- Custom Actions Template -->
    <ng-template #actionsTemplate let-rowData>
      <div class="actions-container">
        @if (rowData.canOperate) {
        <p-button
          label="Edit"
          [text]="true"
          size="small"
          (onClick)="onEdit(rowData)"
          class="action-btn"
        />
        }
      </div>
    </ng-template>
    </app-data-table>
  </div>
</div>
